/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SasUploadLinkResponse } from '../models/SasUploadLinkResponse';
import type { StoriesByIdResponse } from '../models/StoriesByIdResponse';
import type { Story } from '../models/Story';
import type { StoryImage } from '../models/StoryImage';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CommunityStoriesService {
    /**
     * Creates a new story.
     * @param tourId
     * @param stayId
     * @returns Story Created successfully.
     * @throws ApiError
     */
    public static createStory(
        tourId: number,
        stayId: number,
    ): CancelablePromise<Story> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/community/stories',
            query: {
                'tourId': tourId,
                'stayId': stayId,
            },
            errors: {
                400: `Stay is not part of tour.`,
                403: `User is not authorized or lacks entitlement to create story.`,
            },
        });
    }
    /**
     * Updates an existing story.
     * @param requestBody
     * @returns Story Updated successfully.
     * @throws ApiError
     */
    public static updateStory(
        requestBody: Story,
    ): CancelablePromise<Story> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/community/stories',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Stay is not part of tour, rating is outside 1-5, story date is not within stay timeframe or maximum amount of images is exceeded.`,
                403: `User is not authorized or lacks entitlement to update story.`,
            },
        });
    }
    /**
     * Creates a SAS-link to upload an image for a story.
     * @param storyId ID of the story.
     * @param fileExtension Extension of the image to be uploaded (jpg, jpeg, png, webp)
     * @returns SasUploadLinkResponse Successfully created.
     * @throws ApiError
     */
    public static getSasUploadLinkForStory(
        storyId: number,
        fileExtension: string,
    ): CancelablePromise<SasUploadLinkResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/community/stories/{storyId}/images/link',
            path: {
                'storyId': storyId,
            },
            query: {
                'fileExtension': fileExtension,
            },
            errors: {
                400: `Maximum amount of images for story reached or invalid file extension.`,
                403: `User is not authorized to create an upload-link for this story.`,
            },
        });
    }
    /**
     * Confirms an image uploaded via SAS-link, saving metadata in databases.
     * @param storyId ID of the story.
     * @param imageName UUID of the uploaded image.
     * @param fileExtension Extension of the uploaded image (jpg, jpeg, png, webp)
     * @returns StoryImage Successfully confirmed.
     * @throws ApiError
     */
    public static confirmImageUploadForStory(
        storyId: number,
        imageName: string,
        fileExtension: string,
    ): CancelablePromise<StoryImage> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/community/stories/{storyId}/images/confirm',
            path: {
                'storyId': storyId,
            },
            query: {
                'imageName': imageName,
                'fileExtension': fileExtension,
            },
            errors: {
                400: `Provided file extension not supported or the image has already been confirmed.`,
                403: `User is not authorized to confirm an image upload for this story.`,
            },
        });
    }
    /**
     * Get stories by tour ID.
     * Returns stories for a specific tour. Supports cursor-based pagination and sorting by story date.
     * @param tourId ID of the tour
     * @param limit Maximum number of stories to return (default 10)
     * @param cursorId Cursor for pagination: last seen storyId
     * @param cursorDate Cursor for pagination: last seen storyDate
     * @param sort Sort direction: ASC or DESC (default ASC)
     * @param accessKey Access-key for external access
     * @returns StoriesByIdResponse Successfully retrieved stories.
     * @throws ApiError
     */
    public static getStoriesByTourId(
        tourId: number,
        limit: number = 10,
        cursorId?: number,
        cursorDate?: number,
        sort: string = 'ASC',
        accessKey?: string,
    ): CancelablePromise<StoriesByIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/community/tours/{tourId}/stories',
            path: {
                'tourId': tourId,
            },
            query: {
                'limit': limit,
                'cursorId': cursorId,
                'cursorDate': cursorDate,
                'sort': sort,
                'accessKey': accessKey,
            },
            errors: {
                403: `Tour owner does not have entitlement for stories to be viewed by the community.`,
            },
        });
    }
    /**
     * Get stories by compound ID.
     * Returns stories for a specific compound. Supports cursor-based pagination and sorting by story date.
     * @param compoundId ID of the compound
     * @param limit Maximum number of stories to return (default 10)
     * @param cursorId Cursor for pagination: last seen storyId
     * @param cursorDate Cursor for pagination: last seen storyDate
     * @param sort Sort direction: ASC or DESC (default ASC)
     * @param minRating Minimum threshold for rating
     * @param maxRating Maximum threshold for rating
     * @returns StoriesByIdResponse Successfully retrieved stories.
     * @throws ApiError
     */
    public static getStoriesByCompoundId(
        compoundId: number,
        limit: number = 10,
        cursorId?: number,
        cursorDate?: number,
        sort: string = 'ASC',
        minRating?: number,
        maxRating?: number,
    ): CancelablePromise<StoriesByIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/community/compounds/{compoundId}/stories',
            path: {
                'compoundId': compoundId,
            },
            query: {
                'limit': limit,
                'cursorId': cursorId,
                'cursorDate': cursorDate,
                'sort': sort,
                'minRating': minRating,
                'maxRating': maxRating,
            },
            errors: {
                403: `Tour owner does not have entitlement for stories to be viewed by the community.`,
            },
        });
    }
    /**
     * Deletes a story.
     * @param storyId ID of the story to delete.
     * @returns void
     * @throws ApiError
     */
    public static deleteStory(
        storyId: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/community/stories/{storyId}',
            path: {
                'storyId': storyId,
            },
            errors: {
                403: `User is not authorized to delete this story.`,
            },
        });
    }
}
